import clsx from 'clsx';
import React from 'react';
import { getInlineStyles } from '../../../utils/styles';
import styles from './navBar.module.css';

type TNavBarProps = {
    dataTest?: string;
    children: React.ReactNode;
    isSearchBar?: boolean;
    align?: 'left' | 'right' | 'space-between' | 'center';
    insideStories?: boolean;
};
export const NavBar = (props: TNavBarProps) => {
    const getJustifyContent = (props: TNavBarProps) => {
        if (props.isSearchBar || props.align === 'center') {
            return 'center';
        } else if (props.align === 'space-between') {
            return 'space-between';
        } else {
            return props.align === 'left' ? 'start' : 'flex-end';
        }
    };
    const innerClass = clsx(styles.inner, props.insideStories && styles.innerInsideStories, props.isSearchBar && styles.innerSearchBar);
    return (
        <div data-test={props.dataTest} className={styles.container}>
            <div className={innerClass} style={getInlineStyles({ variables: { justifyContent: getJustifyContent(props) } })}>
                {props.children}
            </div>
        </div>
    );
};
